import './styles.scss'
import image from '../../../Assets/Images/quote-modal-img.jpeg'
import { CSSTransition } from 'react-transition-group'
import { useEffect, useRef } from 'react'
import Input from '../../Input'
import InputArea from '../../InputArea'
import CustomButton from '../../CustomButton'
import { useForm } from '../../../Hooks/useForm'
import emailjs from '@emailjs/browser'
import AnimateHeight from 'react-animate-height'

const QuoteForm = ({ showForm, handleClose, ...props }) => {
  const formRef = useRef(null)

  const handleClick = (e) => e?.stopPropagation()

  const { form, reset, onChange } = useForm({
    name: '',
    address: '',
    email: '',
    msg: '',
    loading: false,
    success: null,
    error: null,
  })

  const handleChange = (e) => onChange(e.target.name, e.target.value)

  useEffect(() => {
    return reset
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()

    onChange('loading', true)
    onChange('success', null)
    onChange('error', null)

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        { name: form.name, address: form.address, email: form.email, msg: form.msg },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )

      onChange('success', "Your message was sent! We'll be in touch shortly.")
      setTimeout(() => {
        reset()
        handleClose()
      }, 2500)
    } catch (error) {
      onChange('error', 'Something went wrong. Please try again or email us directly.')
    }

    onChange('loading', false)
  }

  return (
    <CSSTransition
      in={showForm}
      nodeRef={formRef}
      timeout={300}
      unmountOnExit
      classNames="quote-form"
    >
      <form
        ref={formRef}
        onClick={handleClick}
        className="quote-form"
        onSubmit={handleSubmit}
        {...props}
      >
        <div className="quote-form__image">
          <img src={image} alt="" />
        </div>

        <div className="quote-form__content">
          <h5 className="title">Get A Free Quote</h5>

          <div className="name">
            <Input
              title="Full Name"
              required
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              name="name"
            />

            <Input
              title="Email"
              type="email"
              required
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              name="email"
            />
          </div>

          <Input
            title="Address"
            required
            placeholder="123 Main St"
            value={form.address}
            onChange={handleChange}
            name="address"
          />

          <InputArea
            title="Message"
            required
            rows={3}
            value={form.msg}
            onChange={handleChange}
            name="msg"
          />

          <AnimateHeight duration={250} height={form.success ? 'auto' : 0}>
            <div className="quote-form__feedback quote-form__feedback--success">
              {form.success}
            </div>
          </AnimateHeight>

          <AnimateHeight duration={250} height={form.error ? 'auto' : 0}>
            <div className="quote-form__feedback quote-form__feedback--error">
              {form.error}
            </div>
          </AnimateHeight>

          <CustomButton
            loading={form.loading}
            otherClassName="submit"
            type="submit"
            label="SEND MESSAGE"
          />
        </div>
      </form>
    </CSSTransition>
  )
}

export default QuoteForm
